import React, { useEffect, useRef, useState} from 'react';
import PropTypes from 'prop-types';
import { generateId } from '../../utilities/';
import ReactTags from 'react-tag-autocomplete';
import Tag from '../tag/';
import './tag-selector.scss';
import { mapItemsFromStrings } from '../../utilities';

export const TagSelector = ({assistiveText, disabled, items, selected, onItemSelected, onItemDeselected, onItemAdded}) => {
	const [suggestions, setSuggestions] = useState(items);
	const [isAddingItem, setIsAddingItem] = useState(false);
	const [inputValue, setInputValue] = useState(null);
	const reactTags = useRef();
	const { addButton, createNew, placeholder } = assistiveText;

	useEffect(() => {
		setSuggestions(items);
		setIsAddingItem(false);
	}, [items, selected]);

	const handleItemDeselected = (index) => {
		onItemDeselected(index);
  }

  const handleItemSelected = (data) => {
		onItemSelected(data);
		setIsAddingItem(false);
  }

	const renderAddItemMenu = () => {
		return (
			<div className="mult-selector-menu">
				<div className="results-list">
					<div className="no-results">
						<h2>Could not find {inputValue.name}. Would you like to add it?</h2>
						<div className="create-options">
							<h3>{createNew}</h3>
							<h4>{inputValue.name}</h4>
							<button className="primary" onClick={handleItemAdded}>{addButton}</button>
						</div>
					</div>
				</div>
			</div>
		);
	}

	const handleInputChange = (tag) => {
		setIsAddingItem(false);
	}

	const handleValidation = (tag) => {
		if (tag && tag.id) {
			return true;
		}
		setInputValue(tag);
		setIsAddingItem(true);
		return false;
	}

	const handleItemAdded = () => {
		const newItem = {...{id: generateId(inputValue.name)}, ...inputValue};
		onItemAdded(newItem);
		reactTags.current.clearInput();
	}

	return (
		<div className="multi-selector">
			<ReactTags
				ref={reactTags}
				delimiters={[',', 'Enter', 'Tab']}
				maxSuggestionsLength={20}
				placeholderText={placeholder}
				tags={mapItemsFromStrings(selected, items)}
				suggestions={suggestions}
				onDelete={handleItemDeselected}
				onInput={handleInputChange}
				onAddition={handleItemSelected}
				onValidate={handleValidation}
				addOnBlur
				allowNew
				isDisabled={disabled}
				tagComponent={Tag}
			 />
			 {isAddingItem && renderAddItemMenu()}
		</div>
	);
};

TagSelector.propTypes = {
	assistiveText: PropTypes.object,
	items: PropTypes.array,
	selected: PropTypes.array,
	onItemSelected: PropTypes.func,
	onItemDeselected: PropTypes.func,
	onItemAdded: PropTypes.func
};
